import React from 'react'
import { Input, Select } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import get from "lodash/get";
import map from "lodash/map";

const HeaderSelector = ({getTemplates,onSearchTemplate, templates, companies, config, inputRef}) => {
  return (
    <>
        <Select
                style={{ minWidth: 250 }}
                size="middle"
                optionFilterProp="label"
                showSearch
                value={
                  get(templates, "filters.companies")
                    ? get(templates, "filters.companies").split(",")
                    : []
                }
                mode="multiple"
                placeholder="Select Company"
                options={map(companies, (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                allowClear
                onChange={(val) => {
                  getTemplates(get(templates, "filters.page",1), {
                    ...get(templates, "filters"),
                    companies: val.length > 0 ? val.join(",") : undefined,
                  });
                }}
              />
              <Select
                style={{ minWidth: 250 }}
                size="middle"
                optionFilterProp="label"
                showSearch={true}
                allowClear
                placeholder="Select Template Type"
                value={get(templates, "filters.type")}
                options={map(Object.values(get(config, "templates", {})), (template) => ({
                  label: get(template, "name"),
                  value: get(template, "value"),
                }))}
                onChange={(val) => {
                  getTemplates(get(templates, "filters.page",1), {
                    ...get(templates, "filters"),
                    type: val,
                  });
                }}
              />
              <Input
                style={{
                  width: 200,
                }} 
                ref={inputRef}
                onChange={(val) => {
                  onSearchTemplate({
                    ...get(templates, "filters"),
                    query: val.target.value,
                  });
                }}
                allowClear
                onClear={() => {
                        getTemplates(get(templates, "filters.page"), {
                          ...get(templates, "filters"),
                          query: undefined,
                        });
                      }}
                size="middle"
                placeholder="Search Template"
                prefix={<SearchOutlined className="mr-2 text-gray-400" />}
              />
    </>
  )
}

export default HeaderSelector